export default __webpack_public_path__ + "static/media/Mission Control.845e3faa.png";